import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { StreamTypes } from 'store/player/actions.types';
import { selectAppSessionId } from 'store/session/selectors';

import { VideoItem } from 'services/data-manager/types';

import { isEmpty } from 'utils/object';

import { PlayerError } from 'screens/PlayerModal/types';

import { PlayerErrorUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';
import { MOBILE_PLAYBACK_CONTENT_SOURCE, getPlayBackType } from './utils';

type Params = {
    videoItem: VideoItem | undefined;
    playbackType: StreamTypes | undefined;
};

export default function useGetPlayerErrorParams({
    videoItem,
    playbackType,
}: Params) {
    const appSessionId = useSelector(selectAppSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getPlayerErrorParams = useCallback(
        (
            playerError: PlayerError,
            videoSessionId: string | undefined,
        ): PlayerErrorUavParams | undefined => {
            const baseUavParams = getBaseUavParams(UavEvents.PLAYER_ERROR);

            if (
                !isEmpty(playerError) &&
                baseUavParams &&
                videoItem &&
                videoSessionId &&
                appSessionId
            ) {
                return {
                    ...baseUavParams,
                    metadata: {
                        contentSource: MOBILE_PLAYBACK_CONTENT_SOURCE,
                        contentType: getPlayBackType(playbackType),
                        appSessionId,
                        playbackSessionId: videoSessionId,
                        errorCode: playerError.code?.toString() || 'No code',
                        errorMsg:
                            playerError.message ||
                            playerError.description ||
                            '',
                        playerTypeVersion: '', // should be an empty string
                        editorialID: videoItem.id,
                        ...baseUavParams.metadata,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, videoItem, appSessionId, playbackType, videoItem],
    );

    return {
        getPlayerErrorParams,
    };
}
